"use client";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  Box,
  Typography,
  Stack,
  TextField,
  Button,
  CircularProgress,
} from "@mui/material";
import "../auth.css";
import IconButton from "@mui/material/IconButton";
import { postMethod, getMethod } from "../../../services/apiService";
import { SHA512 } from "crypto-js";
import { LogoutModal } from "../../partials/LogoutModal";
import {
  PartnerIdContext,
  usePartnerIdContext,
} from "../../../context/partnerIdContext";
import { Link } from "react-router-dom";
import { PROFILE_TYPE } from "../../../helper/globalConstant";
import { IconEyeOff } from '@tabler/icons-react';
import { IconEye } from '@tabler/icons-react';
interface AuthResponse {
  code: number; // HTTP status code or any other code your API returns
  result?: { jsessionid: string }[]; // Adjust this based on the actual API response structure
  message?: string; // Error message or success message
  [key: string]: any; // Optional: To allow extra properties
}

const Login = () => {
  const navigate = useNavigate();

  //If the user is already logged in then redirect to the /Network page
  useEffect(() => {
    const sess_user = localStorage.getItem("sess_user");
    if (sess_user !== null && sess_user !== undefined && sess_user != "") {
      navigate("/customer/overview");
    } else {
      partnerIdContext.setPartnerId("");
      localStorage.clear();
    }
  }, []);

  // const router = useRouter();
  const [errorMsg, setErrorMsg] = useState("");
  const [loginData, setLoginData] = useState({
    username: "",
    password: "",
  });
  const [loginEmail, setLoginEmail] = useState(false);
  const [loginPassword, setLoginPassword] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [showErrorPopup, setErrorAlert] = useState(false);
  const [showAlertMessage, setShowAlertMessage] = useState("Error");
  const [openLogoutModal, setOpenLogoutModal] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  // Email validation function
  const validateEmail = (email: string) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };

  // Password validation function
  const validatePassword = (password: string): boolean => {
    return password.length !== 0;
  };

  // Handle form submission
  const login = async (e: any) => {
    setIsLoading(true);
    e.preventDefault();
    localStorage.clear();
    // Validate credentials
    if (loginEmail && loginPassword) {
      setErrorMsg("The username or password field can't be empty");
    } else if (loginEmail) {
      setErrorMsg("Please Enter Username!");
    } else if (loginPassword) {
      setErrorMsg("Please Enter Password!");
    } else if (loginData.username === "" && loginData.password === "") {
      setErrorMsg("Please Enter Username and Password!");
      setLoginEmail(true);
      setLoginPassword(true);
    } else if (loginData.username === "") {
      setErrorMsg("Please enter username");
      setLoginEmail(true);
    } else if (loginData.password === "") {
      setErrorMsg("Please enter password");
      setLoginPassword(true);
    } else {
      let payload = {
        username: "F1 Team",
        accountid: loginData.username,
        password: SHA512(loginData.password).toString(),
      };

      const resp = await postMethod("central/user/login", payload);
      if (resp?.data?.code === 200) {
        if (resp?.data?.result?.[0]?.userProfile?.priority > 101) {
          const resp = await getMethod("central/user/auth/logout");
          setErrorMsg("You do not have permission to access this website!");

          // setOpenLogoutModal(true);
        } else {
          document.cookie = `JSESSIONID=${resp?.data?.result[0].JSESSIONID}`;
          localStorage.setItem(
            "sess_user",
            JSON.stringify(resp?.data?.result[0]),
          );
          let loginData = resp.data.result[0];
          let priority = loginData.userProfile?.priority;
          if (
            priority == PROFILE_TYPE.INTEGRATOR_TECHNICIAN_G1 ||
            priority == PROFILE_TYPE.INTEGRATOR_TECHNICIAN_G2
          ) {
            partnerIdContext.setPartnerId(loginData.userProfile?.ownerId);
          } else if (priority == PROFILE_TYPE.INTEGRATOR) {
            partnerIdContext.setPartnerId(loginData.user?.userId);
          }
          navigate("/customer/overview");
        }
      } else {
        setErrorMsg(resp?.data?.message);
      }
    }
    setIsLoading(false);
  };

  const partnerIdContext = usePartnerIdContext();

  // Handle input changes
  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = event.target;
    setLoginData((prevData) => ({
      ...prevData,
      [name]: value,
    }));

    if (name === "username") {
      const isValidUsername = value.trim() !== "";
      setLoginEmail(!isValidUsername);
      setErrorMsg("");
      // partnerIdContext.setPartnerId(value);
    }

    if (name === "password") {
      const isValidPassword = validatePassword(value);
      setLoginPassword(!isValidPassword);
      setErrorMsg("");
    }
  };

  const handleClickShowPassword = () => {
    setShowPassword((prev) => !prev);
  };

  const handleErrorClick = (msg: string) => {
    setErrorAlert(true);
    setShowAlertMessage(msg);
    setTimeout(() => {
      setErrorAlert(false);
    }, 3000);
  };

  return (
    <>
      <Box className="auth-banner">
        <Box className="login-box">
          <Box
            sx={{
              textAlign: "center",
            }}
          >
            <img
              src="/logo.svg"
              alt="Logo"
              style={{ cursor: "pointer", marginBottom: "24px" }}
            />
            <Typography
              sx={{
                fontFamily: "sans-serif",
                fontWeight: 500,
                fontSize: "24px",
                mb: "24px",
              }}
            >
              Login
            </Typography>

            <form onSubmit={(e) => login(e)}>
              <Stack>
                {/* Error message display */}
                <Typography
                  sx={{
                    mb: "24px",
                    fontSize: "14px",
                    textAlign: "center",
                    color: "#FB462E",
                  }}
                >
                  {errorMsg}
                </Typography>

                <Box sx={{ mb: "24px" }}>
                  {/* Email input field */}
                  <TextField
                    variant="outlined"
                    placeholder="Username"
                    type="text"
                    className="textFieldCustom"
                    sx={{
                      width: "100%",
                    }}
                    onChange={handleChange}
                    value={loginData.username}
                    name="username"
                    error={loginEmail}
                  />
                </Box>

                <Box
                  sx={{
                    mb: loginEmail ? "5px" : "3px",
                    position: "relative",
                    width: "100%",
                  }}
                >
                  <TextField
                    variant="outlined"
                    placeholder="Password"
                    type={showPassword ? "text" : "password"}
                    className="textFieldCustom"
                    sx={{
                      width: "100%",
                      input: {
                        paddingRight: "40px",
                      },
                      "& .MuiOutlinedInput-root": {
                        position: "relative",
                      },
                    }}
                    value={loginData.password}
                    name="password"
                    onChange={handleChange}
                    error={loginPassword}
                    autoComplete="new-password"
                  />

                  <IconButton
                    onClick={handleClickShowPassword}
                    sx={{
                      position: "absolute",
                      right: "10px",
                      top: "50%",
                      transform: "translateY(-50%)",
                      padding: 0,
                      height: "100%",
                    }}
                  >
                    {showPassword ? (
                      // <img src="/closed-eye.svg" alt="Icon" />
                      <IconEyeOff stroke={1.4} color="#B4B7B8" />
                    ) : (
                      // <img src="/open-eye.svg" alt="Icon" />
                      <IconEye stroke={1.4} color="#B4B7B8"/>
                    )}
                  </IconButton>
                </Box>

                <Box
                  textAlign={"left"}
                  sx={{
                    mt: "0px",
                    color: "#fff",
                    mb: "24px",
                  }}
                  className="forgotPass"
                >
                  <Link to="/forgot-password">Forgot password?</Link>
                </Box>

                <Button
                  type="submit"
                  variant="contained"
                  sx={{
                    padding: "12px 16px",
                    fontSize: "14px",
                    fontWeight: 500,
                  }}
                  className="auth-btn"
                  disabled={isLoading}
                >
                  {isLoading ? (
                    <CircularProgress size={20} color="inherit" />
                  ) : (
                    "Login"
                  )}
                </Button>
              </Stack>
            </form>
          </Box>
        </Box>
      </Box>

      <LogoutModal
        setOpenLogoutModal={setOpenLogoutModal}
        openLogoutModal={openLogoutModal}
      />

      {showErrorPopup && (
        <Stack
          display="flex"
          flexDirection="row"
          alignItems="center"
          gap="8px"
          className="alertBox"
          sx={{ zIndex: 9999 }}
        >
          <img src="/icons/icon-fail.svg" alt="success" />
          <Box>
            <Typography
              style={{ fontSize: "14px", fontWeight: 700, color: "#E2E3E3" }}
            >
              Error
            </Typography>
            <Typography style={{ fontSize: "12px", color: "#B4B7B8" }}>
              {showAlertMessage}
            </Typography>
          </Box>
        </Stack>
      )}
    </>
  );
};
export default Login;
